import { MicroServiceRuleIds, MSRules } from './microservice-auth-rules';

const FeatureKeys = {
  WALLET_MODULE: 'wallet-module',
  DEPARTMENT_MODULE: 'department-module',
  ADMIN_MODULE: 'admin-module',
  NOTIFICATIONS_MODULE: 'notification-module',
  IMPERSONATION: 'impersonation',
  NEW_DOCUMENT: 'new-document',
  WORKFLOW_MODULE: 'workflow-module',
  GENERIC_ADMIN_ROLE: 'generic-admin',
  GENERIC_BILLING_ROLE: 'generic-billing',
  GENERIC_ADMIN_OR_BILLING_ROLE: 'generic-admin-or-billing',
  RUN_WORKFLOW: 'run-workflow',
  CONTACT_BOOK: 'contact-book',
  INDIVIDUAL_USER: 'individual-user',
  GENERIC_ORG_USER: 'generic-org-user',
  STAMP_MODULE: 'stamp-module',
  BILLING_PROFILE_EXISTS: 'billing-profile-exists',
  MFA_MODULE: 'mfa-module',
  NESL_MODULE: 'nesl-module',
  SFTP_MODULE: 'sftp-module',
  EXCEL_UPLOAD: 'excel-upload',
  EMAIL_EXCEL_UPLOAD: 'email-excel-upload',
  BRAND_COLOUR: 'brand-colour',
  BRAND_LOGO: 'brand-logo',
  CORNER_RADIUS_BRANDING: 'corner-radius-branding',
  AUTO_CHECK_CONSENT: 'auto-check-consent',
  MULTI_BRANDING_PROFILE: 'multi-branding-profile',
  MULTI_STAMPING: 'multi-stamping',
  MULTI_STAMP_SERIES: 'multi-stamp-series',
  TWO_FACTOR_AUTHENTICATION: 'two-factor-authentication',
  REVENUE_STAMPING: 'revenue-stamping',
  AADHAAR_SIGN: 'aadhaar-sign',
  VIRTUAL_SIGN_BIO: 'virtual-sign-bio',
  QUICK_SIGN_BIO: 'quick-sign-bio',
  PHYSICAL_SIGNATURE: 'physical-signature',
  OFFLINE_ESIGN: 'offline-esign',
  OFFLINE_ESIGN_FOREIGN: 'offline-esign-foreign',
  AUTOMATED_SIGN: 'automated-sign',
  DOC_SIGNER: 'doc-signer',
  DSC_SIGN: 'dsc-sign',
  BULK_DSC_SIGNING: 'bulk-dsc-signing',
  VIRTUAL_SIGN: 'virtual-sign',
  QUICK_SIGN: 'quick-sign',
  QUICK_PHYSICAL_SIGN: 'quick-physical-sign',
  SMART_NAME_AI: 'smart-name-ai',
  SMART_USER_LIVELINESS: 'smart-user-liveliness',
  APPROVER: 'approver',
  GROUP_INVITEES: 'group-invitees',
  CC: 'cc',
  CAPTURE_LOCATION: 'capture-location',
  CAPTURE_ACCURACY: 'capture-accuracy',
  COORDINATE_PICKER: 'coordinate-picker',
  REGIONAL_LANGUAGE: 'regional-language',
  FACE_MATCH: 'face-match',
  PII_MASKING: 'pii-masking',
  WHATSAPP: 'whatsapp',
  CONTACT_BOOK_CONFIG: 'contact-book-config',
  PAYMENT_COLLECTION: 'payment-collection',
  AUTOMATED_VIRTUAL_SIGN: 'automated-virtual-sign',
  AUTOMATED_DOC_SIGN: 'automated-doc-sign',
  API_MODULE: 'api-module',
  PDF_EDITOR_MODULE: 'pdf-editor-module',
  VISUAL_SIGN: 'visual-sign',
  VISUAL_SIGN_BIO: 'visual-sign-bio',
  VISUAL_SIGN_PHYSICAL: 'visual-sign-physical',
  EBG_NOTIFICATION: 'ebg-notification',
  DC_ACCESS: 'dc-access',
  CUSTOM_FIELDS: 'custom-fields',
  STAMP_GROUP_MODULE: 'stamp-group-module',
  WORKFLOW_V4_MODULE: 'workflow-v4-module',
  ONLY_WORKFLOW_V3_MODULE: 'only-workflow-v3-module',
  LEE_AI_AGENT: 'lee-ai-agent',
  ONLY_WORKFLOW_V4_MODULE: 'only-workflow-v4-module',
  FULL_WORKFLOW_V4_MODULE: 'full-workflow-v4-module',
  WORKFLOW_V4_DETAILS: 'workflow-v4-details-module',
  TEMPLATE_V4_MODULE: 'template-v4-module',
  TEMPLATE_V4_CREATE: 'template-v4-create-module',
  TEMPLATE_V4_DELETE: 'template-v4-delete-module',
  ONLY_TEMPLATE_V3_MODULE: 'only-template-v3-module',
  PACK_MULTI_DOC: 'pack-multi-doc',
  RULE_ENGINE: 'rule-engine',
  // Automation, served by @leegality/sequence-automation. One key per read
  // entitlement, plus a module key that is true when the user can read anything.
  AUTOMATION_MODULE: 'automation-module',
  AUTOMATION_SEQUENCES: 'automation-sequences',
  AUTOMATION_EVENTS: 'automation-events',
  AUTOMATION_EVENT_RECORDS: 'automation-event-records',
  AUTOMATION_CONNECTORS: 'automation-connectors',
  AUTOMATION_CREDENTIALS: 'automation-credentials',
  AUTOMATION_ACTIVITY_LOGS: 'automation-activity-logs',
  CUSTOM_FIELDS_TOGGLE: 'custom-fields-toggle',
  CUSTOM_VALIDATIONS: 'custom-validations',
  CUSTOM_SENDING_UI: 'custom-sending-ui',
  CUSTOM_FIELD_PAGE: 'custom-field-page',
  DISTRIBUTED_STAMPING: 'distributed-stamping',
  DIGITAL_STAMPING: 'digital-stamping',
  ADVANCED_SIGNING_ORDER: 'advanced-signing-order',
  SIGN_COMBINATION: 'sign-combination',
  WORKFLOW_BUILDER_CONFIG: 'workflow-builder-config',
  REPORTS_MODULE: 'reports-module',
  RETAIN_TEMPLATE_FORM_DATA: 'retain-template-form-data',
  SENDING_SDK: 'sending-sdk',
};

const AccessKeys = {
  ORG_ADMIN: 'org-admin',
  ORG_BILLING_ADMIN: 'org-billing-admin',
  ORG_USER: 'org-user',
  STAMP_ACCESS: 'stamp-access',
  NOTIFICATIONS: 'notifications',
  BULK_REQ_PROFILE: 'bulk-req-profile',
  DEPARTMENT_OWNER: 'department-owner',
  NEW_DOC_ACCESS: 'new-document',
  CONTACT_BOOK: 'contact-book',
  CONTACT_BOOK_ACTIVATED: 'contact-book-activated',
  BILLING_PROFILE_EXISTS: 'billing-profile-exists',
  MFA_ACCESS: 'mfa-access',
  NESL_ACCESS: 'nesl-access',
  SFTP_ACCESS: 'sftp-access',
  EXCEL_UPLOAD_ACCESS: 'excel-upload-access',
  EMAIL_EXCEL_UPLOAD_ACCESS: 'email-excel-upload-access',
  BRAND_COLOUR_ACCESS: 'brand-colour-access',
  BRAND_LOGO_ACCESS: 'brand-logo-access',
  CORNER_RADIUS_BRANDING_ACCESS: 'corner-radius-branding-access',
  AUTO_CHECK_CONSENT_ACCESS: 'auto-check-consent-access',
  MULTI_BRANDING_PROFILE_ACCESS: 'multi-branding-profile-access',
  BRANDING_PROFILE_LIMIT: 'branding-profile-limit',
  MULTI_STAMPING_ACCESS: 'multi-stamping-access',
  MULTI_STAMP_SERIES_ACCESS: 'multi-stamp-series-access',
  TWO_FACTOR_AUTHENTICATION_ACCESS: 'two-factor-authentication-access',
  REVENUE_STAMPING_ACCESS: 'revenue-stamp-access',
  AADHAAR_ACCESS: 'aadhaar-access',
  VIRTUAL_SIGN_BIO_ACCESS: 'virtual-sign-bio-access',
  QUICK_SIGN_BIO_ACCESS: 'quick-sign-bio-access',
  PHYSICAL_SIGNATURE_ACCESS: 'physical-signature-access',
  OFFLINE_ESIGN_ACCESS: 'offline-esign-access',
  OFFLINE_ESIGN_FOREIGN_ACCESS: 'offline-esign-foreign-access',
  AUTOMATED_SIGN_ACCESS: 'automated-sign-access',
  DOC_SIGNER_ACCESS: 'doc-signer-access',
  DSC_SIGN_ACCESS: 'dsc-sign-access',
  BULK_DSC_SIGNING_ACCESS: 'bulk-dsc-signing-access',
  VIRTUAL_SIGN_ACCESS: 'virtual-sign-access',
  VISUAL_SIGN_ACCESS: 'visual-sign-access',
  VISUAL_SIGN_BIO_ACCESS: 'visual-sign-bio-access',
  VISUAL_SIGN_PHYSICAL_ACCESS: 'visual-sign-physical-access',
  QUICK_SIGN_ACCESS: 'quick-sign-access',
  QUICK_PHYSICAL_SIGN_ACCESS: 'quick-physical-sign-access',
  SMART_NAME_AI_ACCESS: 'smart-name-ai-access',
  SMART_USER_LIVELINESS_ACCESS: 'smart-user-liveliness-access',
  SMART_USER_LIVELINESS_V2_ACCESS: 'smart-user-liveliness-v2-access',
  PII_MASKING_ACCESS: 'pii-masking-access',
  APPROVER_ACCESS: 'approver-access',
  GROUP_INVITEES_ACCESS: 'group-invitees-access',
  CC_ACCESS: 'cc-access',
  CAPTURE_LOCATION_ACCESS: 'capture-location-access',
  CAPTURE_LOCATION_ACCURACY: 'capture-location-accuracy',
  COORDINATE_PICKER_ACCESS: 'coordinate-picker-access',
  REGIONAL_LANGUAGE_ACCESS: 'regional-language-access',
  FACE_MATCH_ACCESS: 'face-match-access',
  CAPTURE_FACE_ACCESS: 'capture-face-match',
  WHATSAPP_ACCESS: 'whatsapp-access',
  PAYMENT_COLLECTION: 'payment-collection-access',
  SENDING_SDK_ACCESS: 'sending-sdk-access',
  API_ACCESS: 'api-access',
  PDF_EDITOR_ACCESS: 'pdf-editor-access',
  EBG_NOTIFICATION_ACCESS: 'ebg-notification-access',
  DC_ACCESS: 'dc-access',
  STAMP_GROUP_ACCESS: 'stamp-group-access',
  WORKFLOW_V4_ACCESS: 'workflow-v4-access',
  AUTOMATION_MODULE_ACCESS: 'automation-module-access',
  ONLY_WORKFLOW_V3_ACCESS: 'only-workflow-v3-access',
  LEE_AI_AGENT_ACCESS: 'lee-ai-agent-access',
  TEMPLATE_V4_ACCESS: 'template-v4-access',
  PACK_MULTI_DOC_ACCESS: 'pack-multi-doc-access',
  RULE_ENGINE_ACCESS: 'rule-engine-access',
  CUSTOM_FIELDS_ACCESS: 'custom-fields-access',
  CUSTOM_VALIDATIONS_ACCESS: 'custom-validations-access',
  CUSTOM_SENDING_UI_ACCESS: 'custom-sending-ui-access',
  CUSTOM_FIELD_PAGE_ACCESS: 'custom-field-page-access',
  DISTRIBUTED_STAMPING_ACCESS: 'distributed-stamping-access',
  DIGITAL_STAMPING_ACCESS: 'digital-stamping-access',
  ADVANCED_SIGNING_ORDER_ACCESS: 'advanced-signing-order-access',
  SIGN_COMBINATION_ACCESS: 'sign-combination-access',
  REPORTS_ACCESS: 'reports-access',
};

const AuthRules = {
  [FeatureKeys.GENERIC_ADMIN_ROLE]: (map) => (map[AccessKeys.ORG_ADMIN]),
  [FeatureKeys.GENERIC_BILLING_ROLE]: (map) => (map[AccessKeys.ORG_BILLING_ADMIN]),
  [FeatureKeys.GENERIC_ADMIN_OR_BILLING_ROLE]: (map) => (
    map[AccessKeys.ORG_ADMIN]
    || map[AccessKeys.ORG_BILLING_ADMIN]
  ),
  [FeatureKeys.ADMIN_MODULE]: (map) => (map[AccessKeys.ORG_ADMIN]
     || (!map[AccessKeys.ORG_USER])),
  [FeatureKeys.NOTIFICATIONS_MODULE]: (map) => (map[AccessKeys.NOTIFICATIONS]),
  [FeatureKeys.IMPERSONATION]: (map) => (map[AccessKeys.ORG_ADMIN]),
  [FeatureKeys.WALLET_MODULE]: (map) => (
    map[AccessKeys.ORG_ADMIN]
    || (!map[AccessKeys.ORG_USER])
    || map[AccessKeys.ORG_BILLING_ADMIN]
  ),
  [FeatureKeys.DEPARTMENT_MODULE]: (map) => (
    map[AccessKeys.ORG_ADMIN]
    || !map[AccessKeys.ORG_USER]
    || map[AccessKeys.DEPARTMENT_OWNER]
  ),
  [FeatureKeys.WORKFLOW_MODULE]: (map) => (map[AccessKeys.ORG_USER]),
  [FeatureKeys.NEW_DOCUMENT]: (map) => (map[AccessKeys.NEW_DOC_ACCESS]),
  [FeatureKeys.RUN_WORKFLOW]: (map) => (map[AccessKeys.BULK_REQ_PROFILE]),
  [FeatureKeys.BILLING_PROFILE_EXISTS]: (map) => (map[AccessKeys.BILLING_PROFILE_EXISTS]),
  [FeatureKeys.MFA_MODULE]: (map) => (map[AccessKeys.MFA_ACCESS]),
  [FeatureKeys.STAMP_MODULE]: (map) => (map[AccessKeys.STAMP_ACCESS]),
  [FeatureKeys.NESL_MODULE]: (map) => (map[AccessKeys.NESL_ACCESS]),
  [FeatureKeys.SFTP_MODULE]: (map) => (map[AccessKeys.SFTP_ACCESS]),
  [FeatureKeys.EXCEL_UPLOAD]: (map) => (map[AccessKeys.EXCEL_UPLOAD_ACCESS]),
  [FeatureKeys.EMAIL_EXCEL_UPLOAD]: (map) => (map[AccessKeys.EMAIL_EXCEL_UPLOAD_ACCESS]),
  [FeatureKeys.CONTACT_BOOK]: (map) => map[AccessKeys.CONTACT_BOOK]
  && map[AccessKeys.CONTACT_BOOK_ACTIVATED],
  [FeatureKeys.GENERIC_ORG_USER]: (map) => map[AccessKeys.ORG_USER],
  [FeatureKeys.INDIVIDUAL_USER]: (map) => (!map[AccessKeys.ORG_USER]),
  [FeatureKeys.BRAND_COLOUR]: (map) => (map[AccessKeys.BRAND_COLOUR_ACCESS]),
  [FeatureKeys.BRAND_LOGO]: (map) => (map[AccessKeys.BRAND_LOGO_ACCESS]),
  [FeatureKeys.CORNER_RADIUS_BRANDING]: (map) => (map[AccessKeys.CORNER_RADIUS_BRANDING_ACCESS]),
  [FeatureKeys.AUTO_CHECK_CONSENT]: (map) => (map[AccessKeys.AUTO_CHECK_CONSENT_ACCESS]
    && map[AccessKeys.WORKFLOW_V4_ACCESS]),
  [FeatureKeys.MULTI_BRANDING_PROFILE]: (map) => (map[AccessKeys.MULTI_BRANDING_PROFILE_ACCESS]),
  [FeatureKeys.MULTI_STAMPING]: (map) => (map[AccessKeys.MULTI_STAMPING_ACCESS]),
  [FeatureKeys.MULTI_STAMP_SERIES]: (map) => (map[AccessKeys.MULTI_STAMP_SERIES_ACCESS]),
  [FeatureKeys.TWO_FACTOR_AUTHENTICATION]: (map) => (
    map[AccessKeys.TWO_FACTOR_AUTHENTICATION_ACCESS]),
  [FeatureKeys.REVENUE_STAMPING]: (map) => (map[AccessKeys.REVENUE_STAMPING_ACCESS]),
  [FeatureKeys.AADHAAR_SIGN]: (map) => (map[AccessKeys.AADHAAR_ACCESS]),
  [FeatureKeys.VIRTUAL_SIGN_BIO]: (map) => (map[AccessKeys.VIRTUAL_SIGN_BIO_ACCESS]),
  [FeatureKeys.PHYSICAL_SIGNATURE]: (map) => (map[AccessKeys.PHYSICAL_SIGNATURE_ACCESS]),
  [FeatureKeys.OFFLINE_ESIGN]: (map) => (map[AccessKeys.OFFLINE_ESIGN_ACCESS]),
  // Foreign signing is a sub-mode of Cloud DSC, never a standalone one — the org has to be
  // entitled to Cloud DSC before Foreign means anything.
  [FeatureKeys.OFFLINE_ESIGN_FOREIGN]: (map) => (map[AccessKeys.OFFLINE_ESIGN_ACCESS]
    && map[AccessKeys.OFFLINE_ESIGN_FOREIGN_ACCESS]),
  [FeatureKeys.AUTOMATED_SIGN]: (map) => (map[AccessKeys.AUTOMATED_SIGN_ACCESS]),
  [FeatureKeys.DOC_SIGNER]: (map) => (map[AccessKeys.DOC_SIGNER_ACCESS]),
  [FeatureKeys.DSC_SIGN]: (map) => (map[AccessKeys.DSC_SIGN_ACCESS]),
  [FeatureKeys.BULK_DSC_SIGNING]: (map) => (map[AccessKeys.BULK_DSC_SIGNING_ACCESS]),
  [FeatureKeys.VIRTUAL_SIGN]: (map) => (map[AccessKeys.VIRTUAL_SIGN_ACCESS]),
  [FeatureKeys.SMART_NAME_AI]: (map) => (map[AccessKeys.SMART_NAME_AI_ACCESS]),
  [FeatureKeys.SMART_USER_LIVELINESS]: (map) => (map[AccessKeys.SMART_USER_LIVELINESS_ACCESS]),
  [FeatureKeys.PII_MASKING]: (map) => (map[AccessKeys.PII_MASKING_ACCESS]),
  [FeatureKeys.APPROVER]: (map) => map[AccessKeys.APPROVER_ACCESS],
  [FeatureKeys.GROUP_INVITEES]: (map) => (map[AccessKeys.GROUP_INVITEES_ACCESS]),
  [FeatureKeys.CC]: (map) => (map[AccessKeys.CC_ACCESS]),
  [FeatureKeys.CAPTURE_LOCATION]: (map) => map[AccessKeys.CAPTURE_LOCATION_ACCESS]
  && map[AccessKeys.CAPTURE_LOCATION_ACCURACY],
  [FeatureKeys.COORDINATE_PICKER]: (map) => (map[AccessKeys.COORDINATE_PICKER_ACCESS]),
  [FeatureKeys.REGIONAL_LANGUAGE]: (map) => (map[AccessKeys.REGIONAL_LANGUAGE_ACCESS]),
  [FeatureKeys.FACE_MATCH]: (map) => map[AccessKeys.FACE_MATCH_ACCESS]
  && map[AccessKeys.CAPTURE_FACE_ACCESS],
  [FeatureKeys.WHATSAPP]: (map) => (map[AccessKeys.WHATSAPP_ACCESS]),
  [FeatureKeys.CONTACT_BOOK_CONFIG]: (map) => map[AccessKeys.CONTACT_BOOK],
  [FeatureKeys.PAYMENT_COLLECTION]: (map) => map[AccessKeys.PAYMENT_COLLECTION],
  [FeatureKeys.AUTOMATED_VIRTUAL_SIGN]: (map) => (
    map[AccessKeys.AUTOMATED_SIGN_ACCESS] && map[AccessKeys.VIRTUAL_SIGN_ACCESS]),
  [FeatureKeys.AUTOMATED_DOC_SIGN]: (map) => (
    map[AccessKeys.AUTOMATED_SIGN_ACCESS] && map[AccessKeys.DOC_SIGNER_ACCESS]),
  [FeatureKeys.API_MODULE]: (map) => (map[AccessKeys.API_ACCESS]),
  [FeatureKeys.PDF_EDITOR_MODULE]: (map) => (map[AccessKeys.PDF_EDITOR_ACCESS]),
  [FeatureKeys.QUICK_SIGN]: (map) => (map[AccessKeys.QUICK_SIGN_ACCESS]),
  [FeatureKeys.QUICK_SIGN_BIO]: (map) => (map[AccessKeys.QUICK_SIGN_BIO_ACCESS]),
  [FeatureKeys.QUICK_PHYSICAL_SIGN]: (map) => (map[AccessKeys.QUICK_PHYSICAL_SIGN_ACCESS]),
  [FeatureKeys.VISUAL_SIGN]: (map) => (map[AccessKeys.VISUAL_SIGN_ACCESS]),
  [FeatureKeys.VISUAL_SIGN_BIO]: (map) => (map[AccessKeys.VISUAL_SIGN_BIO_ACCESS]),
  [FeatureKeys.VISUAL_SIGN_PHYSICAL]: (map) => (map[AccessKeys.VISUAL_SIGN_PHYSICAL_ACCESS]),
  [FeatureKeys.EBG_NOTIFICATION]: (map) => (map[AccessKeys.EBG_NOTIFICATION_ACCESS]),
  [FeatureKeys.DC_ACCESS]: (map) => (map[AccessKeys.DC_ACCESS]),
  [FeatureKeys.STAMP_GROUP_MODULE]: (map) => (map[AccessKeys.STAMP_GROUP_ACCESS]),
  [FeatureKeys.WORKFLOW_V4_MODULE]: (map) => (map[AccessKeys.WORKFLOW_V4_ACCESS]),
  [FeatureKeys.ONLY_WORKFLOW_V3_MODULE]: (map) => (!(map[AccessKeys.WORKFLOW_V4_ACCESS]
    && (map[MicroServiceRuleIds.WORKFLOW_V4_LIST] || map[MicroServiceRuleIds.WORKFLOW_V4_CREATE]))
    && map[AccessKeys.BULK_REQ_PROFILE]),
  [FeatureKeys.ONLY_WORKFLOW_V4_MODULE]: (map) => (map[AccessKeys.WORKFLOW_V4_ACCESS]
    && (map[MicroServiceRuleIds.WORKFLOW_V4_LIST] || map[MicroServiceRuleIds.WORKFLOW_V4_CREATE])
    && !map[AccessKeys.BULK_REQ_PROFILE]),
  [FeatureKeys.FULL_WORKFLOW_V4_MODULE]: (map) => (map[AccessKeys.WORKFLOW_V4_ACCESS]
    && (map[MicroServiceRuleIds.WORKFLOW_V4_LIST] || map[MicroServiceRuleIds.WORKFLOW_V4_CREATE])
    && map[AccessKeys.BULK_REQ_PROFILE]),
  [FeatureKeys.WORKFLOW_V4_DETAILS]: (map) => (map[MicroServiceRuleIds.WORKFLOW_V4_GET]),
  [FeatureKeys.TEMPLATE_V4_MODULE]: (map) => (map[AccessKeys.WORKFLOW_V4_ACCESS]
    && map[MicroServiceRuleIds.TEMPLATE_V4_LIST]
  ),
  [FeatureKeys.TEMPLATE_V4_CREATE]: (map) => (map[AccessKeys.WORKFLOW_V4_ACCESS]
    && map[AccessKeys.PDF_EDITOR_ACCESS]
    && map[MicroServiceRuleIds.TEMPLATE_V4_CREATE]
  ),
  [FeatureKeys.TEMPLATE_V4_DELETE]: (map) => (map[AccessKeys.WORKFLOW_V4_ACCESS]
    && map[MicroServiceRuleIds.TEMPLATE_V4_DELETE]
  ),
  [FeatureKeys.ONLY_TEMPLATE_V3_MODULE]: (map) => (!map[AccessKeys.WORKFLOW_V4_ACCESS]
    || !map[MicroServiceRuleIds.TEMPLATE_V4_LIST]
  ),
  [FeatureKeys.CUSTOM_FIELDS]: (map) => (map[AccessKeys.WORKFLOW_V4_ACCESS]
    && map[MicroServiceRuleIds.CUSTOM_FIELDS_LIST]
    && map[AccessKeys.CUSTOM_FIELDS_ACCESS]
  ),
  [FeatureKeys.PACK_MULTI_DOC]: (map) => (map[AccessKeys.PACK_MULTI_DOC_ACCESS]),
  [FeatureKeys.RULE_ENGINE]: (map) => (map[AccessKeys.RULE_ENGINE_ACCESS]),
  // Automation. Each sub-feature is gated on its own read entitlement, so a user
  // sees only the tabs they can actually read. The module itself is visible when
  // any one of them is present.
  [FeatureKeys.AUTOMATION_SEQUENCES]: (map) => (
    map[MicroServiceRuleIds.AUTOMATION_SEARCH_SEQUENCE]
  ),
  [FeatureKeys.AUTOMATION_EVENTS]: (map) => (
    map[MicroServiceRuleIds.AUTOMATION_SEARCH_EVENT]
  ),
  [FeatureKeys.AUTOMATION_EVENT_RECORDS]: (map) => (
    map[MicroServiceRuleIds.AUTOMATION_SEARCH_EVENT_RECORD]
  ),
  [FeatureKeys.AUTOMATION_CONNECTORS]: (map) => (
    map[MicroServiceRuleIds.AUTOMATION_LIST_CONNECTOR]
  ),
  [FeatureKeys.AUTOMATION_CREDENTIALS]: (map) => (
    map[MicroServiceRuleIds.AUTOMATION_LIST_CREDENTIAL]
  ),
  // Logs describe the five resources above, so reading them needs the log
  // entitlement AND at least one resource the logs could be about. The log
  // entitlement alone would show a screen the user cannot interpret.
  [FeatureKeys.AUTOMATION_ACTIVITY_LOGS]: (map) => (
    map[MicroServiceRuleIds.AUTOMATION_SEARCH_ACTIVITY_LOG]
    && (
      map[MicroServiceRuleIds.AUTOMATION_SEARCH_SEQUENCE]
      || map[MicroServiceRuleIds.AUTOMATION_SEARCH_EVENT_RECORD]
      || map[MicroServiceRuleIds.AUTOMATION_SEARCH_EVENT]
      || map[MicroServiceRuleIds.AUTOMATION_LIST_CONNECTOR]
      || map[MicroServiceRuleIds.AUTOMATION_LIST_CREDENTIAL]
    )
  ),
  // Deliberately the five resource reads and not the log entitlement. Logs can
  // never be the only visible tab, so including it here would let the module
  // appear with nothing under it.
  [FeatureKeys.AUTOMATION_MODULE]: (map) => (
    map[AccessKeys.AUTOMATION_MODULE_ACCESS]
    && (
      map[MicroServiceRuleIds.AUTOMATION_SEARCH_SEQUENCE]
      || map[MicroServiceRuleIds.AUTOMATION_SEARCH_EVENT]
      || map[MicroServiceRuleIds.AUTOMATION_SEARCH_EVENT_RECORD]
      || map[MicroServiceRuleIds.AUTOMATION_LIST_CONNECTOR]
      || map[MicroServiceRuleIds.AUTOMATION_LIST_CREDENTIAL]
    )
  ),
  [FeatureKeys.CUSTOM_FIELDS_TOGGLE]: (map) => (map[AccessKeys.CUSTOM_FIELDS_ACCESS]),
  [FeatureKeys.CUSTOM_VALIDATIONS]: (map) => (map[AccessKeys.CUSTOM_VALIDATIONS_ACCESS]),
  [FeatureKeys.CUSTOM_SENDING_UI]: (map) => (map[AccessKeys.CUSTOM_SENDING_UI_ACCESS]),
  [FeatureKeys.CUSTOM_FIELD_PAGE]: (map) => (map[AccessKeys.CUSTOM_FIELD_PAGE_ACCESS]),
  [FeatureKeys.DISTRIBUTED_STAMPING]: (map) => (map[AccessKeys.DISTRIBUTED_STAMPING_ACCESS]),
  [FeatureKeys.DIGITAL_STAMPING]: (map) => (map[AccessKeys.DIGITAL_STAMPING_ACCESS]),
  [FeatureKeys.ADVANCED_SIGNING_ORDER]: (map) => (map[AccessKeys.ADVANCED_SIGNING_ORDER_ACCESS]),
  [FeatureKeys.SIGN_COMBINATION]: (map) => (map[AccessKeys.SIGN_COMBINATION_ACCESS]
    && map[AccessKeys.WORKFLOW_V4_ACCESS]),
  [FeatureKeys.RETAIN_TEMPLATE_FORM_DATA]: (map) => (map[AccessKeys.WORKFLOW_V4_ACCESS]),
  [FeatureKeys.SENDING_SDK]: (map) => (map[AccessKeys.SENDING_SDK_ACCESS]),
  [FeatureKeys.WORKFLOW_BUILDER_CONFIG]: (map) => (
    map[AccessKeys.RULE_ENGINE_ACCESS]
    || map[AccessKeys.CUSTOM_FIELDS_ACCESS]
    || map[AccessKeys.CUSTOM_VALIDATIONS_ACCESS]
    || map[AccessKeys.CUSTOM_SENDING_UI_ACCESS]
    || map[AccessKeys.CUSTOM_FIELD_PAGE_ACCESS]
  ),
  [FeatureKeys.REPORTS_MODULE]: (map) => (
    map[AccessKeys.REPORTS_ACCESS]
    && map[MicroServiceRuleIds.REPORT_READ_REPORT]
  ),
  ...MSRules,
  [FeatureKeys.LEE_AI_AGENT]: (map) => (
    map[AccessKeys.LEE_AI_AGENT_ACCESS]
    && map[MicroServiceRuleIds.LEE_AI_START_CONVERSATION]
  ),
};

export {
  FeatureKeys, AccessKeys, AuthRules,
};
